export default {
    url: '/list',
    template: '<evaluation-list></evaluation-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/evaluation/list/index.js